import React from "react";
import Icon from "../Icon";
import Button from "./Button";

const IconButton = ({
  appearance,
  icon,
  iconSize,
  title,
  notification,
  ...props
}) => {
  return (
    <Button
      {...props}
      appearance={appearance ? `icon-${appearance}` : "icon"}
      title={title}
    >
      <Icon
        icon={icon}
        size={iconSize}
        title={title}
        notification={notification}
      />
    </Button>
  );
};

IconButton.propTypes = {
  title: Icon.propTypes.title,
  icon: Icon.propTypes.icon,
  iconSize: Icon.propTypes.size,
};

export default IconButton;
